import { useContext, useEffect, useState } from 'react';
import { MainContext } from '../../contexts/main';
import { addInvoiceRecipient, getInvoiceRecipients, removeInvoiceRecipient, setInvoiceByEmail } from '../../helpers/api';
import { getText } from '@educaplay/app-core/language';
import { SVG_trash } from '../elements/SVG';

export const BlockInvoiceByEmail = () => {

    const { environment, mainReducer, appReducer } = useContext( MainContext );

    const [ stateSaving, setStateSaving ] = useState(false);
    const [ stateRecipients, setStateRecipients ] = useState(false);
    const [ stateMaxRecipients, setStateMaxRecipients ] = useState(0);
    const [ stateEmail, setStateEmail ] = useState('');
    const [ stateError, setStateError ] = useState(false);

    const enabled = mainReducer.state.currentLicense.invoiceByEmail;

    const requestData = {
        environment: environment.entorno,
        tokenID: environment.tokenID,
        lang: environment.lang
    };

    const applyResponse = (response) => {
        if (response.recipients !== undefined) {
            setStateRecipients(response.recipients);
            setStateMaxRecipients(response.maxRecipients);
        }
        if (!response.success && (response.errors.length == 0)) {
            appReducer.dispatch({
                type: 'setNotifications',
                payload: [{
                    type: 'error',
                    content: getText('notification_payment_unknown')
                }]
            });
        }
        return response;
    };

    const runRequest = async (request) => {
        setStateSaving(true);
        const response = applyResponse(await request);
        setStateSaving(false);
        return response;
    };

    useEffect(() => {
        getInvoiceRecipients(requestData).then(applyResponse);
    }, []);

    const handleChange = async (event) => {
        const newValue = event.target.checked;
        const response = await runRequest(setInvoiceByEmail({ ...requestData, enabled: newValue ? 'true' : 'false' }));
        if (response.success) {
            mainReducer.dispatch({
                type: 'setInvoiceByEmail',
                payload: newValue
            });
        }
    };

    const handleAdd = async (event) => {
        event.preventDefault();
        if (stateEmail.trim() == '') {
            return;
        }
        const response = await runRequest(addInvoiceRecipient({ ...requestData, email: stateEmail }));
        if (response.success) {
            setStateEmail('');
            setStateError(false);
        } else if (response.errors.length > 0) {
            setStateError(response.errors[0]);
        }
    };

    const handleRemove = (id) => {
        runRequest(removeInvoiceRecipient({ ...requestData, id: id }));
    };

    const hasPendingRecipients = (stateRecipients !== false) && stateRecipients.some(recipient => !recipient.verified);

    return  <div className="e-option e-option--expandable mt-md">
                <label className="e-option" htmlFor="invoiceByEmail">
                    <div className="e-option__info">
                        <div className="e-option__hd">
                            <span className="e-text e-text--small-strong">{ getText('enviar_facturas_email') }</span>
                        </div>
                    </div>
                    <div className="e-check e-check--switch">
                        <input type="checkbox" id="invoiceByEmail" checked={ enabled } disabled={ stateSaving } onChange={ handleChange } />
                    </div>
                </label>
                {(enabled && (stateRecipients !== false)) &&
                    <div className="flex flex-column gap-sm">
                        <span className="e-text e-text--sm e-text--gray-dark">
                            { getText((stateRecipients.length == 0) ? 'facturas_sin_destinatarios' : 'facturas_destinatarios') }
                        </span>
                        {stateRecipients.map(recipient =>
                            <div className="flex align-center flex-wrap gap-sm" key={ recipient.id }>
                                <span className="e-text e-text--md">{ recipient.email }</span>
                                {!recipient.verified &&
                                    <span className="e-badge e-badge--warn">{ getText('destinatario_pendiente') }</span>
                                }
                                <button type="button" className="e-btn e-btn--square e-btn--sm" disabled={ stateSaving } onClick={ () => handleRemove(recipient.id) } aria-label={ getText('quitar_destinatario') + ' ' + recipient.email } title={ getText('quitar_destinatario') }>
                                    <span className="e-icon">
                                        <SVG_trash />
                                    </span>
                                </button>
                            </div>
                        )}
                        {hasPendingRecipients &&
                            <span className="e-text e-text--sm e-text--gray-dark">{ getText('destinatario_pendiente_txt') }</span>
                        }
                        {(stateRecipients.length < stateMaxRecipients) &&
                            <form className="flex align-start gap-sm" onSubmit={ handleAdd } noValidate>
                                <div className={`e-form flex-1${stateError ? ' e-form--error' : ''}`}>
                                    <div className="e-form__wrapper">
                                        <span className="e-form__input">
                                            <input type="email" value={ stateEmail } onChange={ (event) => setStateEmail(event.target.value) } placeholder={ getText('anadir_destinatario_placeholder') } aria-label={ getText('anadir_destinatario_placeholder') } disabled={ stateSaving } />
                                        </span>
                                    </div>
                                    {stateError &&
                                        <span className="e-form__note">{ getText('error_destinatario_' + stateError) }</span>
                                    }
                                </div>
                                <button type="submit" className="e-btn e-btn--secondary" disabled={ stateSaving }>{ getText('anadir_destinatario') }</button>
                            </form>
                        }
                    </div>
                }
            </div>;
}
